import { PaletteWithBaseColors } from '@sparknz/spark-pattern-library';

import { PlanOfferDetails } from '../typings';

export enum BalanceManagementType {
  Prepaid = 'PREPAID',
  Postpaid = 'POSTPAID',
}

export const getPlansByBalanceManagementType = (
  plans: PlanOfferDetails,
  balanceManagementType: BalanceManagementType,
): PlanOfferDetails => {
  return plans.filter(
    (plan) =>
      plan.productCharacteristics?.balanceManagement === balanceManagementType,
  );
};

export interface SelectedPlanHelperArgs {
  offerId: string;
  planId: string;
  isChangePlan: boolean;
  existingOfferId: string;
}

export const isPlanSelected = ({
  offerId,
  planId,
  isChangePlan,
  existingOfferId,
}: SelectedPlanHelperArgs) => {
  if (!isChangePlan) {
    return offerId === planId;
  }
  return existingOfferId === offerId;
};

export interface PlanCardCtaLabelArgs {
  isSelected?: boolean;
  isChangePlan: boolean;
  palette?: PaletteWithBaseColors;
  isEligibilityCheckRequired?: boolean;
  isAuthenticatedSparkUser?: boolean;
}

export const getPlanCardCtaLabel = ({
  isSelected,
  isChangePlan,
  isEligibilityCheckRequired,
  isAuthenticatedSparkUser,
}: PlanCardCtaLabelArgs) => {
  if (isSelected && isChangePlan) {
    return 'Current plan';
  }

  if (isSelected) {
    return 'Selected';
  }

  if (isEligibilityCheckRequired) {
    return isAuthenticatedSparkUser
      ? 'Check eligibility'
      : 'Sign in to check eligibility';
  }

  return 'Select plan';
};
